module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAzMCI+Cgk8ZGVmcz4KCQk8c3R5bGU+CgkJCS5jbHMtMXtmaWxsOiNlMmUzZTQ7fS5jbHMtMntmaWxsOiM0MzQzNDU7fQoJCTwvc3R5bGU+Cgk8L2RlZnM+Cgk8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KCQk8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgoJCQk8Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjE1IiBjeT0iMTUiIHI9IjE1IiAvPgoJCQk8cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xOS4xMSw4LjIybC01LDYuNzYsNSw2LjhIMTZMMTAuODksMTUsMTYsOC4yMloiIC8+CgkJPC9nPgoJPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/back-arrow.svg
// module id = 55
// module chunks = 173